import { styled } from '@clickcease/cc-client-components-lib'

export const BotMitigationStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

export const BotMitigationSliderWrapper = styled('div', {
  color: '$primaryColor',
  fontSize: '$h3',
  display: 'flex',
  margin: '40px 0px',

  '@bp1': {
    flexDirection: 'column',
    position: 'relative',
    width: '90%',
    margin: '60px 0px',
    zIndex: 2,
  },
})

export const BotMitigationSliderText = styled('div', {
  color: '$black',
  fontSize: '$h3',
  fontWeight: '$sb',
  marginRight: '$8',

  '@bp1': {
    fontWeight: '$b',
    fontSize: '$lg',
    marginBottom: '$4',
  },
})
